import { render, staticRenderFns } from "./search.vue?vue&type=template&id=088df0be&scoped=true"
import script from "./search.vue?vue&type=script&lang=js"
export * from "./search.vue?vue&type=script&lang=js"
import style1 from "./search.vue?vue&type=style&index=1&id=088df0be&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "088df0be",
  null
  
)

export default component.exports